import React from 'react';
import Image from '@kds/image';
import PlayIcon from '@/assets/icon/playIcon.png';
import { scaleW } from '@/common/style';
import { IVideoCoverType } from './types';

const VideoOrImageCover = ({ url, poster, isVideo = false, style, iconSize = 27 }: IVideoCoverType) => {
    const fallBackImg = 'https://cdn-static.kwai.net/kos/s101/nlav11312/kwr/ui/assets/defaultimg.b606c7d7e784c291.png';
    if (isVideo) {
        return (
            <>
                <Image style={[{ width: '100%', height: '100%' }, style]} source={{ uri: poster || fallBackImg }} resizeMethod="resize" />
                <Image
                    style={{
                        width: scaleW(iconSize),
                        height: scaleW(iconSize),
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: [{ translateX: -scaleW(iconSize / 2) }, { translateY: -scaleW(iconSize / 2) }],
                    }}
                    source={PlayIcon}
                    resizeMethod="resize"
                />
            </>
        );
    }

    return <Image style={[{ width: '100%', height: '100%' }, style]} source={{ uri: url }} resizeMethod="resize" />;
};

export default VideoOrImageCover;
